import { render, staticRenderFns } from "./transportStatement.vue?vue&type=template&id=175f0532&scoped=true&"
import script from "./transportStatement.vue?vue&type=script&lang=ts&"
export * from "./transportStatement.vue?vue&type=script&lang=ts&"
import style0 from "./transportStatement.vue?vue&type=style&index=0&id=175f0532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f0532",
  null
  
)

export default component.exports